// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.augmentedMapMarkerContainer {
  position: absolute;
  display: flex !important;
  text-shadow: none;
  user-select: none;
  -webkit-user-select: none;
  z-index: 0;
  width: 120px;
  height: 120px;
  overflow: visible;
  box-sizing: border-box;
}
.augmentedMapMarkerContainer .augmentedMapMarker {
  position: absolute;
  display: flex;
  width: 120px;
  height: 120px;
  margin: auto;
  border-radius: 100%;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.219);
  user-select: none;
  -webkit-user-select: none;
  font-family: Gothic;
  transform: rotateX(-60deg) scale(0.5) translateY(0vh) rotateZ(0deg);
  animation-fill-mode: none;
  opacity: 0;
  animation: flyFromSky 2s ease-in;
  color: white;
}
@keyframes flyFromSky {
  0% {
    transform: rotateX(50deg) scale(6) translateY(-210vh) rotateZ(60deg);
    opacity: 0;
  }
  20% {
    transform: rotateX(50deg) scale(6) translateY(-210vh) rotateZ(60deg);
    opacity: 1;
  }
  60% {
    transform: rotateX(-60deg) scale(0.5) translateY(0vh) rotateZ(60deg);
    opacity: 0.3;
  }
  100% {
    transform: rotateX(-60deg) scale(0.5) translateY(0vh) rotateZ(0deg);
    opacity: 0.8;
  }
}
.augmentedMapMarkerContainer .augmentedMapMarker.openMarker {
  opacity: 1;
}
.augmentedMapMarkerContainer .augmentedMapMarker.closeMarker {
  opacity: 0;
}
.augmentedMapMarkerContainer .augmentedContent {
  background-color: rgba(36, 36, 36, 0.9098039216);
  position: absolute;
  display: flex;
}
.augmentedMapMarkerContainer .svg-icon {
  font-size: 100px;
  line-height: 24px;
  vertical-align: bottom;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/augmented-map-marker/augmented-map-marker.component.scss"],"names":[],"mappings":"AAIA;EACI,kBAAA;EACA,wBAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,UAAA;EACA,YATU;EAUV,aAVU;EAWV,iBAAA;EACA,sBAAA;AAHJ;AAKI;EACI,kBAAA;EACA,aAAA;EACA,YAjBM;EAkBN,aAlBM;EAmBN,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,4CAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EAEA,mEAAA;EAEA,yBAAA;EACA,UAAA;EACA,gCAAA;EACA,YAAA;AALR;AASI;EACI;IACI,oEAAA;IACA,UAAA;EAPV;EASM;IACI,oEAAA;IACA,UAAA;EAPV;EASM;IACI,oEAAA;IACA,YAAA;EAPV;EASM;IACI,mEAAA;IACA,YAAA;EAPV;AACF;AAUI;EACI,UAAA;AARR;AAWI;EACI,UAAA;AATR;AAYI;EACI,gDAAA;EACA,kBAAA;EACA,aAAA;AAVR;AAaI;EACI,gBAAA;EACA,iBAAA;EACA,sBAAA;AAXR","sourcesContent":["// OBS: We cant contain this in component selector as only part of the dom is inserted as mapbox marker\n\n$marker-size: 120px;\n\n.augmentedMapMarkerContainer  {\n    position: absolute;\n    display: flex !important;\n    text-shadow: none;\n    user-select: none;\n    -webkit-user-select: none;\n    z-index: 0;\n    width: $marker-size;\n    height: $marker-size;\n    overflow: visible;\n    box-sizing: border-box;\n    \n    .augmentedMapMarker {\n        position:absolute;\n        display:flex;\n        width: $marker-size;\n        height: $marker-size;\n        margin: auto;\n        border-radius: 100%;\n        justify-content: center;\n        align-items: center;\n        background-color: rgba(255, 255, 255, 0.219);\n        user-select: none;\n        -webkit-user-select: none;\n        font-family: Gothic;\n        // OBS. This is set in Javascript on zoom level change\n        transform: rotateX(-60deg) scale(0.5) translateY(0vh) rotateZ(0deg);\n        // Fill mode must be none in order to control from JS\n        animation-fill-mode: none;\n        opacity: 0;\n        animation: flyFromSky 2s ease-in;\n        color: white;\n        // color: var(--motes-gold);\n    }\n    \n    @keyframes flyFromSky {\n        0% {\n            transform: rotateX(50deg) scale(6) translateY(-210vh) rotateZ(60deg);\n            opacity: 0;\n        }\n        20% {\n            transform: rotateX(50deg) scale(6) translateY(-210vh) rotateZ(60deg);\n            opacity: 1;\n        }\n        60% {\n            transform: rotateX(-60deg) scale(0.5) translateY(0vh) rotateZ(60deg);\n            opacity: 0.3;\n        }\n        100% {\n            transform: rotateX(-60deg) scale(0.5) translateY(0vh) rotateZ(0deg);\n            opacity: 0.8;\n        }\n    }\n\n    .augmentedMapMarker.openMarker {\n        opacity: 1;\n    }\n    \n    .augmentedMapMarker.closeMarker {\n        opacity: 0;\n    }\n\n    .augmentedContent {\n        background-color: #242424e8;\n        position: absolute;\n        display: flex;\n    }\n    \n    .svg-icon {\n        font-size: 100px;\n        line-height: 24px;\n        vertical-align: bottom;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
